export const SEARCH_STATE = 'search'

export const UPDATE_SEARCH = 'UPDATE_SEARCH'
export const UPDATE_LAST_SUGGESTION = 'UPDATE_LAST_SUGGESTION'
export const UPDATE_SEARCH_FROM_LOCAL_STORAGE = 'UPDATE_SEARCH_FROM_LOCAL_STORAGE'
